import React from "react";

const Option = (props) =>  (
    <div className="option">
        {/* <div className={"check " + ( props.value ? 'checked':'')} onClick={ () => { props.setFunction( !props.value ); }  }></div> */}
        <p>{ props.title }</p>
    </div>
)

export default Option;